(function () {
  var stickyMarker = document.querySelector('[data-site-header-sticky]');
  if (!stickyMarker) return;

  var header = stickyMarker.closest('.site-header') || stickyMarker;

  var hideClass = 'site-header--scroll-hidden';
  var lastScrollY = window.scrollY;
  var ticking = false;

  // Other sticky elements (e.g. the collection filter sidebar) need to know
  // how much space the header is *currently* occupying, not just its full
  // height, since that space collapses to ~0 whenever the header is hidden.
  function updateOffset(isHidden) {
    document.documentElement.style.setProperty(
      '--sticky-header-offset',
      isHidden ? '0px' : header.offsetHeight + 'px'
    );
  }

  function onScroll() {
    var currentScrollY = window.scrollY;
    var headerHeight = header.offsetHeight;
    var isHidden = header.classList.contains(hideClass);

    if (currentScrollY <= headerHeight) {
      isHidden = false;
    } else if (currentScrollY > lastScrollY) {
      isHidden = true;
    } else if (currentScrollY < lastScrollY) {
      isHidden = false;
    }

    header.classList.toggle(hideClass, isHidden);
    updateOffset(isHidden);

    lastScrollY = currentScrollY;
    ticking = false;
  }

  updateOffset(false);

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
